import { omit } from "lodash";

import { CRUDAction, IEntityFetchCollectionSuccess, RequestAction } from "../actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "../reducer";

import { ReplyAddressAction, ReplyAddressActionsNames } from "./actions";
import { IFetchReplyAddressSuccessPayload, IReplyAddress, ISyncDeleteReplyAddressPayload } from "./interfaces";

const initialState: State = { loading: false, entities: {} };

type State = { entities: IEntityCollectionState<IReplyAddress>; loading: boolean };

const replyAddressesReducer: (state: State, action: ReplyAddressAction) => State = (state = initialState, action) => {
  switch (action.type) {
    case ReplyAddressActionsNames[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]: {
      const { id, value } = action.payload as IFetchReplyAddressSuccessPayload;

      return { loading: false, entities: { ...state.entities, [id]: value } };
    }
    case ReplyAddressActionsNames[CRUDAction.FETCH_SINGLE][RequestAction.REQUEST]: {
      return { ...state, loading: true };
    }
    case ReplyAddressActionsNames[CRUDAction.FETCH_SINGLE][RequestAction.FAILURE]: {
      return { ...state, loading: false };
    }
    case ReplyAddressActionsNames[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      const { values } = action.payload as IEntityFetchCollectionSuccess<IReplyAddress>;

      const newValues = values.reduce((m, v) => ({ ...m, [v.id]: v }), {});
      return { entities: { ...state.entities, ...newValues }, loading: false };
    }
    case ReplyAddressActionsNames.SYNC_DELETE: {
      const { id } = action.payload as ISyncDeleteReplyAddressPayload;
      const newEntities = omit(state.entities, id);

      return { ...state, entities: newEntities };
    }
    default:
      return state;
  }
};

export default replyAddressesReducer;
